/**
 * Events API service (Task 6/Sprint 1). Tenant/ownership-scoped server-side.
 */
import apiClient from '@/services/api/client';

export const listEvents = async () => (await apiClient.get('/v1/events')).data;
export const createEvent = async (p) => (await apiClient.post('/v1/events', p)).data;
export const updateEvent = async (id, p) => (await apiClient.put(`/v1/events/${id}`, p)).data;
export const approveEvent = async (id) => (await apiClient.post(`/v1/events/${id}/approve`)).data;
export const publishEvent = async (id) => (await apiClient.post(`/v1/events/${id}/publish`)).data;
export const archiveEvent = async (id) => (await apiClient.post(`/v1/events/${id}/archive`)).data;
export const deleteEvent = async (id) => apiClient.delete(`/v1/events/${id}`);
